import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";

import { Eyebrow, Title } from "../components/CommonComponents";
import MetaInfo from "../components/MetaInfo";
import Header from "../components/Header";
import Footer from "../components/Footer";

import DrVinayVideo from "../assets/img/media/Dr. Vinay Agrawal.mp4";
import PMModiVideo from "../assets/img/media/PM Modi.mp4";

import { Arrow, Close, Play, News } from "../components/CommonComponents";

const mediaVideos = [
  {
    id: 11,
    url: PMModiVideo,
    title:
      "PM Modi launches ‘Nasha Mukt Yuva for Viksit Bharat Sankalp Abhiyan’ via VC",
    type: "local",
  },
  {
    id: 12,
    url: DrVinayVideo,
    title: "ChangeMakers: Dr. Vinay Agrawal, ISBM University",
    type: "local",
  },
  {
    id: 10,
    url: "https://www.youtube.com/embed/DSzDkpF8Oug",
    title: "ZEE MPCG के मंच पर उद्योग जगत के दिग्गज",
    type: "youtube",
  },
  {
    id: 9,
    url: "https://www.youtube.com/embed/msaIBvKXjws",
    title: "Media Coverage of IBC24",
    type: "youtube",
  },
  {
    id: 8,
    url: "https://www.youtube.com/embed/d-H0D7OaRp0",
    title: "Media Coverage of Edumate TV",
    type: "youtube",
  },
  {
    id: 7,
    url: "https://www.youtube.com/embed/d-RIDjYSYFE",
    title: "Media Coverage of Swaraj Express",
    type: "youtube",
  },
  {
    id: 6,
    url: "https://www.youtube.com/embed/490Sw_wiZW8",
    title: "Media Coverage of Desh TV",
    type: "youtube",
  },
  {
    id: 5,
    url: "https://www.youtube.com/embed/jgS_lbVI428",
    title: "Media Coverage of IBC24 News",
    type: "youtube",
  },
  {
    id: 4,
    url: "https://www.youtube.com/embed/HqxxM7QkteM",
    title: "Media Coverage of Swaraj Express",
    type: "youtube",
  },
  {
    id: 3,
    url: "https://www.youtube.com/embed/qxvf9KPvKAw",
    title: "Media Coverage of Swaraj Express",
    type: "youtube",
  },
  {
    id: 2,
    url: "https://www.youtube.com/embed/VO2P-OGklh8",
    title: "Media Coverage of Glibs.in news",
    type: "youtube",
  },
  {
    id: 1,
    url: "https://www.youtube.com/embed/MWLWh0hgGa0",
    title: "Media Coverage of Futsal League",
    type: "youtube",
  },
];

export default function MediaCoverage() {
  const [mediaData, setMediaData] = useState([]);
  const [activeTab, setActiveTab] = useState("media");
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMedia();
  }, []);

  useEffect(() => {
    if (!selectedMedia) return undefined;
    const onKeyDown = (event) =>
      event.key === "Escape" && setSelectedMedia(null);
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [selectedMedia]);

  const fetchMedia = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        "https://isbmuniversity.edu.in/admin-portal/mediaApi",
      );
      setMediaData(Array.isArray(res.data) ? res.data : []);
    } catch (error) {
      console.error("Error fetching media:", error);
      setMediaData([]);
    } finally {
      setLoading(false);
    }
  };

  const newspaperCoverage = useMemo(
    () => mediaData.filter((item) => item.category === "media"),
    [mediaData],
  );

  return (
    <>
      <MetaInfo param="" id="about" />
      <Header school="common" />

      <main className="overflow-hidden bg-white">
        {/* HERO */}
        <section className="relative isolate overflow-hidden bg-[#071A2F] pt-[100px] text-white">
          <div className="absolute inset-0 -z-30 bg-[radial-gradient(circle_at_82%_20%,rgba(213,173,87,0.18),transparent_26%),radial-gradient(circle_at_12%_82%,rgba(139,30,63,0.25),transparent_30%)]" />
          <div className="absolute inset-0 -z-20 opacity-[0.055] [background-image:linear-gradient(rgba(255,255,255,.35)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.35)_1px,transparent_1px)] [background-size:72px_72px]" />
          <div className="absolute -right-[220px] top-[40px] -z-10 h-[680px] w-[680px] rounded-full border border-white/10" />

          <div className="mx-auto grid min-h-[580px] w-[min(1380px,calc(100%-48px))] items-center gap-16 pb-20 max-sm:w-[calc(100%-28px)] lg:grid-cols-[1.02fr_.98fr]">
            <div>
              <div className="flex items-center gap-4 text-sm font-bold uppercase tracking-[0.18em] text-[#D5AD57]">
                <span className="h-px w-12 bg-current" />
                Media Coverage
              </div>
              <h1 className="mt-7 max-w-[790px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(52px,6.6vw,94px)] font-normal leading-[0.95] tracking-[-0.05em]">
                Stories that travel
                <span className="block text-[#D5AD57]">beyond our campus.</span>
              </h1>
              <p className="mt-8 max-w-[660px] text-[17px] leading-8 text-white/65">
                Explore television features, interviews, digital news coverage
                and newspaper stories featuring ISBM University.
              </p>
              <div className="mt-10 flex flex-wrap gap-4">
                <button
                  type="button"
                  onClick={() =>
                    document
                      .getElementById("coverage-archive")
                      ?.scrollIntoView({ behavior: "smooth" })
                  }
                  className="inline-flex min-h-[54px] items-center gap-7 rounded-full bg-[#D5AD57] px-7 text-xs font-bold uppercase tracking-[0.12em] text-[#071A2F] transition hover:-translate-y-0.5"
                >
                  Explore Coverage <Arrow />
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setActiveTab("newspaper");
                    setTimeout(
                      () =>
                        document
                          .getElementById("coverage-archive")
                          ?.scrollIntoView({ behavior: "smooth" }),
                      50,
                    );
                  }}
                  className="inline-flex min-h-[54px] items-center gap-7 rounded-full border border-white/20 px-7 text-xs font-bold uppercase tracking-[0.12em] text-white transition hover:border-white/50"
                >
                  Press Archive <News />
                </button>
              </div>
            </div>

            <div className="relative hidden min-h-[500px] lg:block">
              <div className="absolute right-0 top-0 w-[430px] overflow-hidden rounded-[34px] border border-white/10 bg-white/[0.07] p-5 backdrop-blur-xl">
                <div className="relative aspect-video overflow-hidden rounded-[24px] bg-black">
                  <video
                    muted
                    loop
                    autoPlay
                    playsInline
                    className="h-full w-full object-cover opacity-80"
                  >
                    <source src={DrVinayVideo} type="video/mp4" />
                  </video>
                  <div className="absolute inset-0 bg-gradient-to-t from-[#071A2F]/80 via-transparent to-transparent" />
                  <span className="absolute bottom-5 left-5 inline-flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.15em] text-white">
                    <span className="grid h-8 w-8 place-items-center rounded-full bg-[#D5AD57] text-[#071A2F]">
                      <Play />
                    </span>
                    Featured Coverage
                  </span>
                </div>
                <div className="grid grid-cols-2 gap-px pt-5">
                  <div className="border-r border-white/10 px-3 py-4 text-end">
                    <strong className="font-['Libre_Caslon_Display',Georgia,serif] text-[46px] font-normal leading-none text-[#D5AD57]">
                      {mediaVideos.length}
                    </strong>
                    <span className="mt-2 block text-[10px] uppercase tracking-[0.13em] text-white/40">
                      Video Features
                    </span>
                  </div>
                  <div className="px-6 py-4 text-end">
                    <strong className="font-['Libre_Caslon_Display',Georgia,serif] text-[46px] font-normal leading-none">
                      {newspaperCoverage.length || "—"}
                    </strong>
                    <span className="mt-2 block text-[10px] uppercase tracking-[0.13em] text-white/40">
                      Press Records
                    </span>
                  </div>
                </div>
              </div>
              <div className="absolute bottom-2 left-0 w-[270px] rounded-[28px] bg-[#8B1E3F] p-7 shadow-[0_25px_70px_rgba(0,0,0,.28)]">
                <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#D5AD57]">
                  In the Spotlight
                </span>
                <p className="mt-5 font-['Libre_Caslon_Display',Georgia,serif] text-[27px] font-normal leading-[1.25]">
                  News, conversations and stories that document our journey.
                </p>
              </div>
            </div>
          </div>

          <div className="border-t border-white/10 bg-white/[0.035] backdrop-blur-lg">
            <div className="mx-auto grid w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)] sm:grid-cols-3">
              <div className="py-6 sm:border-r sm:border-white/10 sm:px-8">
                <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#D5AD57]">
                  01
                </span>
                <p className="mt-2 text-sm font-semibold text-white/80">
                  Television & Digital News
                </p>
              </div>
              <div className="py-6 sm:border-r sm:border-white/10 sm:px-8">
                <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#D5AD57]">
                  02
                </span>
                <p className="mt-2 text-sm font-semibold text-white/80">
                  Interviews & Features
                </p>
              </div>
              <div className="py-6 sm:px-8">
                <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#D5AD57]">
                  03
                </span>
                <p className="mt-2 text-sm font-semibold text-white/80">
                  Newspaper Coverage
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* EDITORIAL INTRO */}
        <section className="bg-white py-20 sm:py-24 lg:py-28">
          <div className="mx-auto grid w-[min(1380px,calc(100%-48px))] gap-12 max-sm:w-[calc(100%-28px)] lg:grid-cols-[.72fr_1.28fr] lg:gap-20">
            <div>
              <Eyebrow>University in the Media</Eyebrow>
              <Title
                before="Coverage That"
                highlight="Captures Our Journey"
                after=""
                position="middle"
                theme="burgundy"
              />
            </div>
            <div className="lg:pt-8">
              <p className="font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(28px,3vw,43px)] font-normal leading-[1.32] text-[#071A2F]">
                From television conversations to newspaper features, our media
                archive brings together moments when ISBM University's work,
                people and activities reached wider audiences.
              </p>
              <div className="mt-10 grid gap-px bg-[#071A2F]/10 sm:grid-cols-3">
                <div className="bg-[#F7F2E8] p-6">
                  <span className="text-[10px] font-bold uppercase tracking-[0.14em] text-[#8B1E3F]">
                    Watch
                  </span>
                  <p className="mt-3 text-sm font-semibold leading-6 text-[#071A2F]">
                    Broadcasts & Interviews
                  </p>
                </div>
                <div className="bg-[#EEF4F8] p-6">
                  <span className="text-[10px] font-bold uppercase tracking-[0.14em] text-[#8B1E3F]">
                    Read
                  </span>
                  <p className="mt-3 text-sm font-semibold leading-6 text-[#071A2F]">
                    Press & Newspaper Stories
                  </p>
                </div>
                <div className="bg-[#F4E8EC] p-6">
                  <span className="text-[10px] font-bold uppercase tracking-[0.14em] text-[#8B1E3F]">
                    Discover
                  </span>
                  <p className="mt-3 text-sm font-semibold leading-6 text-[#071A2F]">
                    University Media Archive
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* COVERAGE ARCHIVE */}
        <section id="coverage-archive" className="relative overflow-hidden bg-white py-20 sm:py-24 lg:py-28">

          <div className="absolute right-0 top-0 h-[420px] w-[32%] bg-[#F7F2E8]" />
          <div className="absolute bottom-0 left-0 h-[300px] w-[24%] bg-[#EEF4F8]" />

          <div className="relative mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

            {/* SECTION HEADING */}
            <div className="grid gap-10 lg:grid-cols-[.8fr_1.2fr] lg:items-end">

              <div>
                <Eyebrow>Media Archive</Eyebrow>

                <Title
                  before="Stories That"
                  highlight="Made Headlines"
                  after=""
                  position="middle"
                  theme="burgundy"
                />
              </div>

              <div className="lg:pb-3">
                <p className="max-w-[620px] text-[16px] leading-8 text-[#65727E]">
                  Explore television features, interviews, digital stories and newspaper
                  coverage highlighting ISBM University's people, initiatives and
                  achievements.
                </p>
              </div>

            </div>


            {/* TAB NAVIGATION */}
            <div className="mt-12 flex flex-wrap border-b border-[#071A2F]/15">

              <button type="button" onClick={() => setActiveTab("media")} className={`relative flex min-h-[64px] items-center gap-3 px-7 text-[11px] font-bold uppercase tracking-[0.14em] transition ${activeTab === "media" ? "text-[#8B1E3F]" : "text-[#071A2F]/45 hover:text-[#071A2F]"}`}>
                <Play />

                Video Coverage

                {activeTab === "media" && (
                  <span className="absolute bottom-[-1px] left-0 h-[3px] w-full bg-[#8B1E3F]" />
                )}
              </button>

              <button type="button" onClick={() => setActiveTab("newspaper")} className={`relative flex min-h-[64px] items-center gap-3 px-7 text-[11px] font-bold uppercase tracking-[0.14em] transition ${activeTab === "newspaper" ? "text-[#8B1E3F]" : "text-[#071A2F]/45 hover:text-[#071A2F]"}`}>
                <News />

                Newspaper Coverage

                {activeTab === "newspaper" && (
                  <span className="absolute bottom-[-1px] left-0 h-[3px] w-full bg-[#8B1E3F]" />
                )}
              </button>

            </div>


            {/* VIDEO COVERAGE */}
            {activeTab === "media" && (
              <div className="mt-12">

                {/* FEATURED VIDEO */}
                {mediaVideos.length > 0 && (
                  <div className="grid overflow-hidden bg-[#071A2F] lg:grid-cols-[1.45fr_.55fr]">

                    <div className="relative aspect-video overflow-hidden bg-black lg:aspect-auto lg:min-h-[520px]">

                      {mediaVideos[0].type === "local" ? (
                        <video controls preload="metadata" className="absolute inset-0 h-full w-full object-cover">
                          <source src={mediaVideos[0].url} type="video/mp4" />
                        </video>
                      ) : (
                        <iframe src={mediaVideos[0].url} title={mediaVideos[0].title} className="absolute inset-0 h-full w-full" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen />
                      )}

                    </div>


                    <div className="relative flex flex-col justify-between p-8 text-white sm:p-10 lg:p-12">

                      <div>

                        <div className="flex items-center gap-3">
                          <span className="h-px w-10 bg-[#D5AD57]" />

                          <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#D5AD57]">
                            Featured Coverage
                          </span>
                        </div>

                        <span className="mt-12 block font-['Libre_Caslon_Display',Georgia,serif] text-[64px] font-normal leading-none text-white/10">
                          01
                        </span>

                        <h3 className="mt-6 font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(28px,3vw,42px)] font-normal leading-[1.12]">
                          {mediaVideos[0].title}
                        </h3>

                      </div>


                      <div className="mt-12 border-t border-white/15 pt-6">

                        <div className="flex items-center gap-3 text-[10px] font-bold uppercase tracking-[0.14em] text-white/50">

                          <span className="grid h-9 w-9 place-items-center rounded-full bg-[#D5AD57] text-[#071A2F]">
                            <Play />
                          </span>

                          Watch Featured Story

                        </div>

                      </div>

                    </div>

                  </div>
                )}


                {/* MORE VIDEO STORIES */}
                <div className="mt-14">

                  <div className="mb-7 flex items-center justify-between gap-5">

                    <div className="flex items-center gap-4">
                      <span className="h-px w-10 bg-[#8B1E3F]" />

                      <span className="text-[10px] font-bold uppercase tracking-[0.17em] text-[#8B1E3F]">
                        More Media Stories
                      </span>
                    </div>

                    <span className="text-[10px] font-bold uppercase tracking-[0.13em] text-[#071A2F]/35">
                      {mediaVideos.length - 1} Stories
                    </span>

                  </div>


                  <div className="grid gap-x-7 gap-y-10 md:grid-cols-2 lg:grid-cols-3">

                    {mediaVideos.slice(1).map((video, index) => (

                      <article key={`${video.id}-${index}`} className="group">

                        <div className="relative aspect-video overflow-hidden bg-[#071A2F]">

                          {video.type === "local" ? (
                            <video controls preload="metadata" className="h-full w-full object-cover">
                              <source src={video.url} type="video/mp4" />
                            </video>
                          ) : (
                            <iframe src={video.url} title={video.title} className="h-full w-full" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen />
                          )}

                          <span className="pointer-events-none absolute left-4 top-4 bg-[#071A2F]/90 px-3 py-2 text-[9px] font-bold tracking-[0.13em] text-[#D5AD57]">
                            {String(index + 2).padStart(2, "0")}
                          </span>

                        </div>


                        <div className="border-b border-[#071A2F]/15 py-5">

                          <div className="flex items-center gap-3 text-[9px] font-bold uppercase tracking-[0.15em] text-[#8B1E3F]">
                            <span className="h-1.5 w-1.5 rounded-full bg-[#8B1E3F]" />
                            Media Feature
                          </div>

                          <h3 className="mt-3 font-['Libre_Caslon_Display',Georgia,serif] text-[24px] font-normal leading-[1.25] text-[#071A2F]">
                            {video.title}
                          </h3>

                        </div>

                      </article>

                    ))}

                  </div>

                </div>

              </div>
            )}


            {/* NEWSPAPER COVERAGE */}
            {activeTab === "newspaper" && (
              <div className="mt-12">

                {loading ? (

                  <div className="grid min-h-[350px] place-items-center bg-[#F7F2E8]">

                    <div className="text-center">

                      <div className="mx-auto h-10 w-10 animate-spin rounded-full border-[3px] border-[#071A2F]/10 border-t-[#8B1E3F]" />

                      <p className="mt-5 text-sm text-[#65727E]">
                        Loading newspaper coverage...
                      </p>

                    </div>

                  </div>

                ) : newspaperCoverage.length > 0 ? (

                  <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">

                    {newspaperCoverage.map((item, index) => {

                      const isImage = item.file?.match(/\.(jpg|jpeg|png|webp)$/i);

                      const isPDF = item.file?.match(/\.pdf$/i);

                      const fileUrl = `https://isbmuniversity.edu.in/admin-server/public/uploads/media/${item.file}`;

                      return (

                        <button key={item.id || `${item.file}-${index}`} type="button" onClick={() => setSelectedMedia({ type: isImage ? "image" : "pdf", src: fileUrl, title: item.title || "Newspaper Coverage" })} className="group relative text-left">

                          {/* PUBLICATION FRAME */}
                          <div className={`relative flex h-[430px] items-center justify-center overflow-hidden p-7 ${index % 3 === 0 ? "bg-[#F7F2E8]" : index % 3 === 1 ? "bg-[#EEF4F8]" : "bg-[#F4E8EC]"}`}>

                            {/* CORNER NUMBER */}
                            <span className="absolute left-0 top-0 z-10 grid h-14 w-14 place-items-center bg-[#071A2F] font-['Libre_Caslon_Display',Georgia,serif] text-[20px] text-[#D5AD57]">
                              {String(index + 1).padStart(2, "0")}
                            </span>


                            {isImage ? (

                              <img src={fileUrl} alt={item.title || "Newspaper coverage"} className="h-full w-full object-contain shadow-[0_18px_45px_rgba(7,26,47,0.13)] transition duration-500 group-hover:scale-[1.025]" />

                            ) : (

                              <div className="relative flex h-[260px] w-[190px] flex-col items-center justify-center bg-white shadow-[0_20px_55px_rgba(7,26,47,0.12)]">

                                <div className="absolute left-0 top-0 h-[6px] w-full bg-[#8B1E3F]" />

                                <span className="grid h-16 w-16 place-items-center rounded-full bg-[#F4E8EC] text-[#8B1E3F]">
                                  <News />
                                </span>

                                <strong className="mt-6 text-[11px] uppercase tracking-[0.16em] text-[#071A2F]">
                                  {isPDF ? "Press PDF" : "Media File"}
                                </strong>

                                <span className="mt-3 text-[10px] uppercase tracking-[0.12em] text-[#071A2F]/35">
                                  ISBM University
                                </span>

                              </div>

                            )}


                            {/* VIEW OVERLAY */}
                            <div className="absolute inset-0 flex items-center justify-center bg-[#071A2F]/0 opacity-0 transition duration-300 group-hover:bg-[#071A2F]/70 group-hover:opacity-100">

                              <span className="inline-flex items-center gap-4 bg-white px-5 py-3 text-[10px] font-bold uppercase tracking-[0.13em] text-[#071A2F]">
                                View Coverage
                                <Arrow />
                              </span>

                            </div>

                          </div>


                          {/* CAPTION */}
                          <div className="py-5">

                            <div className="flex items-center gap-3">

                              <span className="h-px w-8 bg-[#8B1E3F]" />

                              <span className="text-[9px] font-bold uppercase tracking-[0.15em] text-[#8B1E3F]">
                                Press Coverage
                              </span>

                            </div>

                            <h3 className="mt-3 font-['Libre_Caslon_Display',Georgia,serif] text-[23px] font-normal leading-[1.25] text-[#071A2F]">
                              {item.title || (isPDF ? "Newspaper Coverage PDF" : "ISBM University in the News")}
                            </h3>

                          </div>

                        </button>

                      );

                    })}

                  </div>

                ) : (

                  <div className="grid min-h-[340px] place-items-center bg-[#F7F2E8] p-10 text-center">

                    <div>

                      <span className="mx-auto grid h-16 w-16 place-items-center rounded-full bg-white text-[#8B1E3F] shadow-sm">
                        <News />
                      </span>

                      <h3 className="mt-6 font-['Libre_Caslon_Display',Georgia,serif] text-[30px] font-normal text-[#071A2F]">
                        No newspaper coverage available
                      </h3>

                    </div>

                  </div>

                )}

              </div>
            )}

          </div>

        </section>

        {/* CLOSING */}
        <section className="bg-[#071A2F] py-16 text-white sm:py-20">
          <div className="mx-auto flex w-[min(1380px,calc(100%-48px))] flex-col gap-8 max-sm:w-[calc(100%-28px)] lg:flex-row lg:items-center lg:justify-between">
            <div>
              <span className="text-xs font-bold uppercase tracking-[0.16em] text-[#D5AD57]">
                ISBM University in the Media
              </span>
              <h2 className="mt-4 max-w-[760px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(32px,4vw,52px)] font-normal leading-[1.1]">
                A living archive of stories, conversations and recognition.
              </h2>
            </div>
            <button
              type="button"
              onClick={() => {
                setActiveTab("media");
                document
                  .getElementById("coverage-archive")
                  ?.scrollIntoView({ behavior: "smooth" });
              }}
              className="inline-flex min-h-[54px] shrink-0 items-center justify-center gap-6 rounded-full border border-white/20 px-7 text-xs font-bold uppercase tracking-[0.12em] text-white transition hover:border-[#D5AD57] hover:text-[#D5AD57]"
            >
              View Coverage <Arrow />
            </button>
          </div>
        </section>
      </main>

      {selectedMedia && (
        <div
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#071A2F]/95 p-4 backdrop-blur-md sm:p-8"
          onClick={() => setSelectedMedia(null)}
        >
          <div
            className="relative flex max-h-[92vh] w-full max-w-[1200px] flex-col overflow-hidden rounded-[28px] bg-white shadow-[0_35px_120px_rgba(0,0,0,.4)]"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="flex items-center justify-between border-b border-[#071A2F]/10 px-6 py-5 sm:px-8">
              <div>
                <span className="text-[9px] font-bold uppercase tracking-[0.15em] text-[#8B1E3F]">
                  {selectedMedia.type === "image"
                    ? "Newspaper Image"
                    : "PDF Viewer"}
                </span>
                <h3 className="mt-1 font-['Libre_Caslon_Display',Georgia,serif] text-[22px] text-[#071A2F]">
                  {selectedMedia.title}
                </h3>
              </div>
              <button
                type="button"
                onClick={() => setSelectedMedia(null)}
                className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-[#F4E8EC] text-[#8B1E3F] transition hover:bg-[#8B1E3F] hover:text-white"
                aria-label="Close media viewer"
              >
                <Close />
              </button>
            </div>
            <div className="min-h-0 flex-1 overflow-auto bg-[#EEF4F8] p-4 sm:p-7">
              {selectedMedia.type === "image" ? (
                <div className="flex min-h-[60vh] items-center justify-center">
                  <img
                    src={selectedMedia.src}
                    alt={selectedMedia.title}
                    className="max-h-[76vh] max-w-full object-contain shadow-[0_16px_55px_rgba(7,26,47,.12)]"
                  />
                </div>
              ) : (
                <iframe
                  src={selectedMedia.src}
                  title="PDF Viewer"
                  className="h-[72vh] w-full rounded-[16px] bg-white"
                />
              )}
            </div>
            {selectedMedia.type === "pdf" && (
              <div className="flex justify-end border-t border-[#071A2F]/10 bg-white px-6 py-4 sm:px-8">
                <a
                  href={selectedMedia.src}
                  download
                  className="inline-flex min-h-[46px] items-center gap-5 rounded-full bg-[#8B1E3F] px-6 text-[10px] font-bold uppercase tracking-[0.13em] text-white"
                >
                  Download PDF <Arrow />
                </a>
              </div>
            )}
          </div>
        </div>
      )}

      <Footer />
    </>
  );
}
